export default __webpack_public_path__ + "static/media/tree.11b5e034.png";